import { Route } from '@angular/router';
import { pageUrls } from './configuration/pages';
import { authGuard } from '@core/guards/auth.guard';
import { roleGuard } from '@core/guards/role.guard';

export const routes: Route[] = [
  // Auth
  {
    path: pageUrls.login,
    loadComponent: () => import('@modules/auth/login/login.component').then((m) => m.LoginComponent),
    data: { animation: 'login' },
  },
  {
    path: pageUrls.passwordForgot,
    loadComponent: () =>
      import('@modules/auth/password-forget/password-forget.component').then((m) => m.PasswordForgetComponent),
    data: { animation: 'passwordForgot' },
  },
  {
    path: pageUrls.passwordReset,
    loadComponent: () =>
      import('@modules/auth/password-reset/password-reset.component').then((m) => m.PasswordResetComponent),
    data: { animation: 'passwordReset' },
  },

  // Features
  { path: '', redirectTo: pageUrls.dashboard, pathMatch: 'full' },
  {
    path: pageUrls.dashboard,
    loadComponent: () => import('@modules/dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [authGuard],
    data: { animation: 'dashboard' },
  },
  {
    path: pageUrls.assetTypes,
    loadComponent: () => import('@modules/asset-types/asset-types.component').then((m) => m.AssetTypesComponent),
    canActivate: [authGuard, roleGuard('asset-types', ['GET'])],
    data: { animation: 'assetTypes' },
  },
  {
    path: pageUrls.assets,
    loadComponent: () => import('@modules/assets/assets.component').then((m) => m.AssetsComponent),
    canActivate: [authGuard, roleGuard('assets', ['GET'])],
    data: { animation: 'assets' },
  },
  {
    path: pageUrls.locations,
    loadComponent: () => import('@modules/locations/locations.component').then((m) => m.LocationsComponent),
    canActivate: [authGuard, roleGuard('locations', ['GET'])],
    data: { animation: 'locations' },
  },
  {
    path: pageUrls.devices,
    loadComponent: () => import('@modules/devices/devices.component').then((m) => m.DevicesComponent),
    canActivate: [authGuard, roleGuard('devices', ['GET'])],
    data: { animation: 'devices' },
  },
  {
    path: pageUrls.scanHistories,
    loadComponent: () =>
      import('@modules/scan-histories/scan-histories.component').then((m) => m.ScanHistoriesComponent),
    canActivate: [authGuard, roleGuard('scan-histories', ['GET'])],
    data: { animation: 'scanHistories' },
  },
  {
    path: pageUrls.users,
    loadComponent: () => import('@modules/users/users.component').then((m) => m.UsersComponent),
    canActivate: [authGuard, roleGuard('users', ['GET'])],
    data: { animation: 'users' },
  },
  {
    path: pageUrls.rolePermissions,
    loadComponent: () =>
      import('@modules/role-permissions/role-permissions.component').then((m) => m.RolePermissionsComponent),
    canActivate: [authGuard, roleGuard('roles', ['POST'])],
    data: { animation: 'rolePermissions' },
  },
  {
    path: pageUrls.logs,
    loadComponent: () => import('@modules/log-viewer/log-viewer.component').then((m) => m.LogViewerComponent),
    canActivate: [authGuard, roleGuard('logs', ['GET'])],
    data: { animation: 'logs' },
  },
  {
    path: pageUrls.exportHistory,
    loadComponent: () => import('@modules/exports/export-history').then((m) => m.ExportHistoryComponent),
    canActivate: [authGuard, roleGuard('exports', ['GET'])],
    data: { animation: 'exportHistory' },
  },
  {
    path: pageUrls.importHistory,
    loadComponent: () => import('@modules/imports/import-history').then((m) => m.ImportHistoryComponent),
    canActivate: [authGuard, roleGuard('imports', ['GET'])],
    data: { animation: 'importHistory' },
  },
  {
    path: pageUrls.sftpExports,
    loadComponent: () =>
      import('@modules/scan-history-export-profiles/scan-history-export-profiles.component').then(
        (m) => m.ScanHistoryExportProfilesComponent,
      ),
    canActivate: [authGuard, roleGuard('scan-history-export-profiles', ['GET'])],
    data: { animation: 'sftpExports' },
  },
  {
    path: pageUrls.settings,
    loadComponent: () => import('@modules/settings/settings.component').then((m) => m.SettingsComponent),
    canActivate: [authGuard, roleGuard('settings', ['PATCH'])],
    data: { animation: 'settings' },
  },
  {
    path: pageUrls.profile,
    loadComponent: () => import('@modules/profile/profile.component').then((m) => m.ProfileComponent),
    canActivate: [authGuard],
    data: { animation: 'profile' },
  },
  {
    path: pageUrls.forbidden,
    loadComponent: () => import('@modules/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
    data: { animation: 'forbidden' },
  },

  // Default (404)
  { path: '**', redirectTo: pageUrls.login },
];
